export default "__VITE_ASSET__N7FbnalY__"